var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.502,
    height: 22.051,
    viewBox: "0 0 31.502 22.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-youtube",
    d: "M33.086,10.418a3.938,3.938,0,0,0-2.779-2.779C27.855,6.975,18,6.975,18,6.975s-9.855,0-12.307.664a3.938,3.938,0,0,0-2.779,2.779A40.646,40.646,0,0,0,2.25,18a40.647,40.647,0,0,0,.664,7.583,3.938,3.938,0,0,0,2.779,2.779c2.453.664,12.307.664,12.307.664s9.855,0,12.307-.664a3.938,3.938,0,0,0,2.779-2.779A40.646,40.646,0,0,0,33.75,18a40.646,40.646,0,0,0-.664-7.583ZM14.85,22.725v-9.45L23.029,18Z",
    transform: "translate(-2.249 -6.975)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.1a509f09d2fdafacb0e3220d050dd9a4.svg";
export { ForwardRef as ReactComponent };